import React, { useState, useEffect } from "react";
import "../Assests/Scss/StudentStatus.scss";
import axios from "axios";
// Below are for import the components
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import AddStudent from "./AddStudent";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import Loading from "../../Student/Reusablecomponents/Loading";
// Below are for import the functions
import { exportToExcel } from "../../Student/Reusablecomponents/RegularFunctions";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { FaAnglesLeft } from "react-icons/fa6";
// Below are for import icons
import { RiFileExcel2Fill } from "react-icons/ri";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { useSelector, useDispatch } from "react-redux";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import { ViewUserActivityLog } from "../../ReusableComponents/CommonApis";
import { FaClockRotateLeft } from "react-icons/fa6";
import { useNavigate,useLocation } from "react-router-dom";
const StudentDetails = (props) => {
  const dispatch = useDispatch();
const location = useLocation();
const navigate = useNavigate();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const [SCount, SetSCount] = useState();
  const [SelectGrade, SetSelectGrade] = useState();
  const [SelectedSutdents, SetSelectedSutdents] = useState([]);

  const [OpenForm, CloseForm] = useState(false);

  const [Students, SetStudents] = useState();
  const [EditStudent, SetEditStudent] = useState();
  const [LogData, SetLogData] = useState();

  const [DisplayStudentSection, SetDisplayStudentSection] = useState("All");
  const [DisplayStudentStatus, SetDisplayStudentStatus] = useState("Active");
const DisableGrades = items?.assessmentGrades?.split(",").map((Grade)=> parseInt(Grade.trim())) || [];
  const [Load, SetLoad] = useState(false);
  // Below function is for make a student Active and inactive
  const StudentActiveStatus = async (userid, Satus) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/UpdateStudentStatus?UserID=${ userid}&IsActive=${Satus}&ModifiedBy=${items?.userId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        StudentDetails(SelectGrade);
        StudentCount();
        notify("Successfully changed the student status", "success");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (userid, Satus, Name) => {
    if (
      window.confirm(
        `Are you sure you want to ${
          Satus ? "activate" : "inactivate"
        } the student : ${Name} `
      )
    ) {
      StudentActiveStatus(userid, Satus);
    } else {
    }
  };

  // Below function is for get the all student details of each grade
  const StudentDetails = async (grade) => {
    SetLoad((prev) => !prev);
    SetStudents();
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetStudentDetailsByClass?SchoolId=${location?.state?.SchoolID || items?.schoolId
          }&Class=${grade}&Active=${DisplayStudentStatus === "Active" ? 1 : 0}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].userId) {
          let Data = res.data.map((row) => {
            if (row.dateOfBirth) {
              row.dateOfBirth = new Date(row.dateOfBirth)
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                .replace(/ /g, "");
            } else {
              row.dateOfBirth = "";
            }
            row.fullName = `${row.firstName} ${row.lastName}`;
            return row;
          });

          if (DisplayStudentSection !== "All") {
            Data = Data.filter((row) => row.section === DisplayStudentSection);
          }
          SetStudents(
            Data.length > 0 ? Data : process.env.REACT_APP_NODATAFOUND
          );
        } else {
          SetStudents(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Below function is for Get the registration count and grade of school
  const StudentCount = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetClassWiseStudentCount?SchoolId=${location?.state?.SchoolID || items?.schoolId}&Section=${DisplayStudentSection}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.class) {
          const sortedData = res.data.sort((a, b) => a.class - b.class);
          StudentDetails(SelectGrade || sortedData[0].class);
          // SetSelectGrade(SelectGrade || sortedData[0].class);>= 6
          const Grades = res.data.filter((item) => item.class);
          SetSelectGrade(SelectGrade || Grades[0].class);

          SetSCount(Grades);
        } else {
          SetSCount();
          SetStudents(process.env.REACT_APP_NODATAFOUND);
          StudentDetails(SelectGrade);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    StudentCount();
  }, [DisplayStudentStatus, DisplayStudentSection, SelectGrade]);

  const AddStudentForm = () => {
    CloseForm(!OpenForm);
    SetEditStudent();
  };

  const handleEdit = (SingleStudent) => {
    CloseForm(!OpenForm);
    SetEditStudent(SingleStudent);
  };

  const columns = [
    {
      name: "Student ID",
      selector: "loginId",
      sortable: true,
      cell: (row) => (
        <div
          onClick={() => !location?.state?.SchoolName &&  handleEdit(row)}
          title={!location?.state?.SchoolName && "Click to edit the student details"}
          className={!location?.state?.SchoolName && "LinkStyles"}
        >
          {row.loginId}
        </div>
      ),
    },
    {
      name: "Name",
      selector: "fullName",
      sortable: false,
      Hcell: (row) => <div style={{ textAlign: "justify" }}>{row.name}</div>,
      cell: (row) => <div style={{ textAlign: "justify" }}>{row.fullName}</div>,
    },
    { name: "Gender", selector: "gender", sortable: true },
    { name: "Date of Birth", selector: "dateOfBirth", sortable: true },
    { name: "Section", selector: "section", sortable: true },
    ...(SelectGrade >= 11
      ? [
          {
            name: "Elective Subject",
            selector: "electiveSubjectName",
            sortable: false,
          },
        ]
      : []),
    {
      name: "Medium of Instruction",
      selector: "mediumOfInstructionVal",
      sortable: true,
    },
   ...((SelectGrade <= 10 ) ? [{
      name: "Language",
      selector: "optionalSubjectName",
      sortable: true,
    }] : []),
    ...(items?.societyName === "NATCO" ?[{
        name: "PST Status", selector: "pstStatusName", sortable: true, }]:[]),
   ...(!DisableGrades?.includes(SelectGrade)?[ {
      name: "Action",
      cell: (row) => (
        <div
          onClick={() =>
            Conformation(row.userId, row.isActive ? 0 : 1, row.fullName)
          }
          className="LinkStyles"
        >
          {!row.isActive ? "Make active" : "Make inactive"}{" "}
        </div>
      ),
    },]:[])
  ];

  const DownloadScholldata = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/DownloadSchoolStudentsData?SchoolId=${ location?.state?.SchoolID ||  items?.schoolId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.[0]?.loginId) {
          const XL = res.data?.map((item, index) => {
            return {
              SNo: index + 1,
              StudentId: item.loginId,
              "Student Name": `${item.firstName} ${item.lastName}`,
              Gender: item.gender,
              "Date of Birth": new Date(item.dateOfBirth)
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })
                .replace(/ /g, ""),
              Grade: item.grade,
              Section: item.section,
              "Medium of Instruction":item.mediumOfInstructionVal,
              Language: item.optionalSubjectName || "NA",
              "Elective Subject":item.electiveSubjectName || "NA",
              // "PST Status": item?.pstStatusName || "NA"
                ...(items?.societyName === "NATCO" && {
    "PST Status": item?.pstStatusName || "NA",
  }),
            };
          });
          exportToExcel(
            XL,
            `${location?.state?.SchoolName || items?.schoolName} - Student Logins for NSF`,
            false,
            `${location?.state?.SchoolID || items?.schoolId}`,
            `${location?.state?.SchoolName || items?.schoolName} - Student Logins for NSF`,
            true
          );
        } else {
          notify("No student are avaliable in the Institue", "error");
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const MakeStatusChange = async () => {
    if (
      window.confirm(
        `Are you sure you want to ${
          DisplayStudentStatus !== "Active" ? "Active" : "Inactive"
        } the selected students ?`
      )
    ) {
      const GetUserids = SelectedSutdents?.map((item) => item.userId);
      const ApiDetails = {
        Activeorinactive: DisplayStudentStatus !== "Active" ? 1 : 0,
        StudentIds: GetUserids.map(String),
        modifiedBy: items?.userId,
      };
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL +
            `/School/ActivateOrInactivateStudents`,
          ApiDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          StudentCount();
          SetSelectedSutdents([]);
          notify(
            "The status of the selected students was updated successfully",
            "success"
          );
        })
        .catch((err) => {
          notify(
            "The status of the selected students was not updated",
            "error"
          );
        });
    }
  };
  const GradeTabs = SCount?.map((item) => ({
    // Name: `Grade ${item.class} (${item.totalStudentCount})`,
    Name: `Grade ${item.class} ${
      DisplayStudentStatus === "Active"
        ? `(${item.totalActiveStudentCount})`
        : `(${item.totalInActiveStudentCount})`
    }`,
    Value: item.class,
  }));

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
      {location?.state?.SchoolID &&  <button className="BackNavigation Buttons dflex alignitems JCCenter gap-1" onClick={() => navigate(-1)}> <FaAnglesLeft/> Back</button>}
        <div
          className="dflex alignitems JSBetween HeadingDiv mt-1 "
          style={{ padding: "0vw 2vw" }}
        >
          <b
            className="dflex gap-2 alignitems"
            style={{
              whiteSpace: "nowrap",
              color: "#4450D3",
              cursor: "pointer",
            }}
            onClick={() => SetLogData(true)}
          >
            <FaClockRotateLeft fontSize={20} /> View Activity Log
          </b>
          <div className="MainHeading">Student Registrations</div>
          <div className="dflex alignitems">
            {DisplayStudentStatus === "Active" && (
              <div className="ExportExcel dflex gap-2 alignitems" onClick={DownloadScholldata}>
                <RiFileExcel2Fill /> Download all grades Students details
              </div>
            )}
            {/* <span
              className="LinkStyles"
              style={{ whiteSpace: "nowrap", cursor: "pointer" }}
              onClick={() => SetLogData(true)}
            >
              View Activity Log
            </span> */}
          </div>
        </div>

        {LogData && (
          <ViewUserActivityLog
            UserId={ location?.state?.UserID || items?.userId}
            UTId={4}
            Close={() => SetLogData(false)}
          />
        )}

        <TabViewValues
          Tabs={GradeTabs}
          Selectedtab={SelectGrade}
          onClick={(e) => {
            SetSelectGrade(e);
            SetSelectedSutdents([]);
          }}
        />
        <div className="dflex JSBetween alignitems Student-Details mt-3">
          <div className="SubHeading">
            {" "}
            {`${DisplayStudentStatus} Students - ${
              DisplayStudentSection.length > 1
                ? `${DisplayStudentSection} Sections`
                : `Section ${DisplayStudentSection}`
            }  : ${Students?.[0]?.userId ? Students?.length : "-"} `}{" "}
          </div>
          <div className="dflex RegisteredSections">
            <label>Section</label>
            {
            ["All", (items.section || location?.state?.Section)?.split(",").map((SEC)=>SEC.trim())].flat()
            // ["All", "A", "B", "C", "D","X"]
            
            .map((section) => (
              <div
                key={section}
                className="dflex alignitems"
                style={{ gap: "3px" }}
              >
                <input
                  type="radio"
                  name="Sections"
                  value={section}
                  defaultChecked={DisplayStudentSection === section}
                  onChange={(e) => {
                    SetDisplayStudentSection(e.target.value);
                    SetSelectedSutdents([]);
                  }}
                />
                {section}{" "}
              </div>
            ))}
          </div>
          <div className="dflex alignitems Export-Add">
            {(SelectedSutdents.length > 0 && !DisableGrades?.includes(SelectGrade))? (
              <button className="Buttons" onClick={() => MakeStatusChange()}>
                Make {DisplayStudentStatus === "Active" ? "Inactive" : "Active"}
              </button>
            ) : (
              <div></div>
            )}

            {!DisableGrades.includes(SelectGrade) ?
            <div className="dflex" style={{ gap: "10px" }}>
              <span>
                {" "}
                <input
                  type="radio"
                  name="ActiveStatus"
                  value="Active"
                  defaultChecked={DisplayStudentStatus === "Active"}
                  onChange={(e) => {
                    SetDisplayStudentStatus(e.target.value);
                    SetSelectedSutdents([]);
                  }}
                />{" "}
                Active{" "}
              </span>
              <span style={{ color: "#878997" }}>
                {" "}
                <input
                  type="radio"
                  name="ActiveStatus"
                  value="Inactive"
                  defaultChecked={DisplayStudentStatus === "Inactive"}
                  onChange={(e) => {
                    SetDisplayStudentStatus(e.target.value);
                    SetSelectedSutdents([]);
                  }}
                />{" "}
                Inactive{" "}
              </span>
            </div>: <div></div>}

            {/* <div /*onClick={DownloadExcel}>{/*Students?.length > 0 && <><RiFileExcel2Fill /> Export </></div> */}
            {!location?.state?.SchoolName ? DisplayStudentStatus === "Active" && (
              <div onClick={AddStudentForm} className="dflex  alignitems">
                <HiMiniPlusSmall /> Add Student
              </div>
            ) : ""}
          </div>
        </div>

        {/* <TabViews Tabs={props.count?.map(item => `Grade ${ item.class } `)} Selectedtab="Grade 7" /> */}
        {Students?.[0]?.userId ? (
          <>
            <div className="Card mt-2 mb-3">
              {Students && (
                <>
                  <DataTable
                    ShowPagecount={true}
                    ShowPagination={true}
                    Dropdownvalues={["10", "25", "50", "100"]}
                    data={Students}
                    columns={columns}
                    showCheckboxes={!DisableGrades?.includes(SelectGrade)}
                    GetSelectData={SetSelectedSutdents}
                    PostSelectData={SelectedSutdents}
                    className="NCLDataTable"
                  />
                  <div className="Info-Message">
                    Click on <b>Student ID</b> to edit student details. | Click
                    on{" "}
                    <b>
                      {DisplayStudentStatus === "Active"
                        ? "Make inactive"
                        : "Make active"}
                    </b>{" "}
                    to{" "}
                    {DisplayStudentStatus === "Active"
                      ? "inactivate"
                      : "Activate"}{" "}
                    student.
                  </div>
                </>
              )}
            </div>{" "}
          </>
        ) : (
          <div className="ErrorMessage">{Students}</div>
        )}

        {Load && <Loading />}
        {OpenForm && (
          <div className="Model-Open">
            <AddStudent
              Cancle={CloseForm}
              EditDetails={EditStudent}
              StudentCount={StudentCount}
              Grade={SelectGrade}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default StudentDetails;
